import axios from 'axios';
import { Article } from './subtopics.types';

const ROOT_SELECTOR = '.subtopics';

export function initSubTopics(): void {
    document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach(initSubTopicsRoot);
}

function initSubTopicsRoot(subtopics: HTMLElement): void {
    let isLoading = false;
    let topic = '';

    const articlesContainer = subtopics.querySelector('.questions-list__items');
    const loadMoreBtn = subtopics.querySelector('.questions-list__load-more');

    const fetchFaqArticles = async (): Promise<Article[]> => {
        const pathParts = window.location.pathname.split('/');
        const pageName = document.documentElement.dataset.pageName || '';

        topic = pageName || pathParts[pathParts.length - 1].replaceAll('-', ' ') || '';

        try {
            const response = await axios.get<Article[]>(`/api/articles?topic=${encodeURIComponent(topic)}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const renderArticle = ({ title, url }: Article): string => {
        const absoluteLink = new URL(url.replace('~', ''), window.location.origin).toString();
        return `
            <li class="questions-list__item">
                <a class="questions-list__card" href="${absoluteLink}">
                    <span class="questions-list__text">${title}</span>
                    <img class="questions-list__chevron" src="/assets/img/arrow-right.svg" alt="" aria-hidden="true" />
                </a>
            </li>
        `.trim();
    };

    const appendArticles = (articles: Article[]): void => {
        if (!articlesContainer) return;

        const fragment = document.createDocumentFragment();
        const temp = document.createElement('ul');
        temp.innerHTML = articles.map(renderArticle).join('');

        while (temp.firstChild) {
            fragment.appendChild(temp.firstChild);
        }

        articlesContainer.appendChild(fragment);
    };

    const setLoadingState = (loading: boolean): void => {
        if (!loadMoreBtn) return;
        isLoading = loading;
        (loadMoreBtn as HTMLButtonElement).disabled = loading;
        loadMoreBtn.textContent = loading ? 'Loading...' : 'Load more';
    };

    const loadArticles = async (): Promise<void> => {
        if (isLoading) return;

        setLoadingState(true);

        try {
            const response = await fetchFaqArticles();

            appendArticles(response);
        } catch (error) {
            console.error('Failed to fetch help topics:', error);
        } finally {
            setLoadingState(false);
        }
    };

    loadArticles();
}
